<template>
    <div class="Ask">
        <Box title="设备申请" :rightButton="SHZT=='1'||SHZT=='2'?'':'添加明细'" path="/askAdd">
            <div class="infoBox">
                <van-cell>
                    <template>
                        <div class='TotalMoney'>
                             <span>申请单号</span>
                             <span :class="data.DH?'':'TextColorWHilt'">{{data.DH?data.DH:'系统自动生成'}}</span>
                        </div>
                    </template>
                </van-cell>

              <!--  <Field title="计划类型" :tabSelected="data.NDJH" type="teb" :data="[{id:'0',name:'科室申请'},{id:'1',name:'年度计划'}]"
                    @onMessage="data.NDJH=arguments[0].id" /> -->
                <Field title="申请科室" name="departmentList" :text="data.KSMC" @manuconfirm="data.KS=arguments[0].a,data.KSMC=arguments[0].b"
                    type="manufacturer" placeholder="请选择" />
                <Field title="申请时间" placeholder="请选择" type="text" :text="data.RQ" @onMessage="data.RQ=arguments[0]" />
                <Field title="申请人" :text="data.ZDRXM" type="text" />
                <Field title="申请理由" placeholder="请输入" :text="data.SQYY" type="textarea" :Isdisabled="false" @onMessage="data.SQYY=arguments[0]" />
            </div>
            <div class="infoBox items" v-for="(item, index) in rows">
                <div class="itemTopBox">
                    <span style="color: #14171a;font-size: 4.533vw;font-weight: 600;">设备列表</span>
                    <div>
                        <span>设备名称</span>
                        <span>{{item.SBMC}}</span>
                    </div>
                    <div>
                        <span>设备别名</span>
                        <span>{{item.SBBM}}</span>
                    </div>
                    <div>
                        <span>数量</span>
                        <span>{{item.CGSL}}</span>
                    </div>
                    <div>
                        <span>单价(元)</span>
                        <span>{{Number(item.CGDJ).toFixed(2)}}</span>
                    </div>
                    <div>
                        <span>总金额</span>
                        <span>{{Number(item.CGJE).toFixed(2)}}</span>
                    </div>
                    <div>
                        <span>规格型号</span>
                        <span>{{item.SBGG}}</span>
                    </div>
                    <div>
                        <span>单位</span>
                        <span>{{item.SBDW}}</span>
                    </div>
                    <div>
                        <span>购置类别</span>
                        <span>{{item.GZLBMC}}</span>
                    </div>
                    <div>
                        <span>是否国产</span>
                        <span>{{item.SFJKMC}}</span>
                    </div>
                    <div>
                        <span>生产厂家</span>
                        <span>{{item.SCQYMC}}</span>
                    </div>
                    <div>
                        <span>供应商</span>
                        <span>{{item.GYSMC}}</span>
                    </div>
                </div>
                <div class="itemBottomBox">
                    <div @click="ReportGoToUrl(item)">
                        {{
                        loadpageButton(item.CGDJ)
                    }}</div>
                    <div @click="()=>{
                        item.CGDJ=Number(item.CGDJ).toFixed(2);
                        $router.push({name: 'AskAdd',params: {item,SHZT}})

                    }">{{(SHZT=='1'||SHZT=='2')?'查看':'修改'}}</div>
                </div>
            </div>
            <Footer v-if="!(SHZT=='1'||SHZT=='2')" :button="[{text:'提交',color:'#fff',background:'#4FA69E',event:'upload'},{text:'保存',color:'#fff',background:'#4FA69E',event:'save'}]"
                @upload="upload" @save="save" />
        </Box>
    </div>
</template>

<script>
    import {cell} from 'vant'
    import Box from '../../components/commonBox/commonBox'
    import Field from '../../components/field/field'
    import Footer from '../../components/footer/footer'
    export default {
        name: 'Ask',
        data() {
            return {
                IsNewAdd:true,
                data: !!this.$route.params.item ? this.$route.params.item : {
                    DH:null,
                    RQ: this.$format(new Date(), 'YYYY-MM-DD'),
                    ZDRXM: this.$UserInfo.UserName,
                    ZDR: this.$UserInfo.UserId,
                    KS: this.$UserInfo.DepartmentId,
                    KSMC: this.$UserInfo.DepartmentName,
                    NDJH: '0',
                    SQYY: ''
                }, //上页带过来
                showDiaLog: false,
                selectIndex: 0,
                outTime: 0, //延迟时间
                NowDepartmentName: this.$UserInfo.DepartmentName,
                rows: [],
                placeholder: '系统自动生成', //系统自动生成提醒
                SQR: this.$UserInfo.UserName, //申请人
                CGJEBZ: '0',
                SHZT: this.$route.params.item ? this.$route.params.item.ZT : '0', //审核状态 为1  2  时不允许做修改
            }
        },
        created() {
            //askAdd页面点击保存传过来的对象
            this.$Bus.$on('updateAskRows', res => { //子组件接收数据
                this.IsNewAdd=false;
                res.HH=res.HH?res.HH:0;
                let rowIndex = this.rows.findIndex(x => x.CGDJ==res.CGDJ && x.CGSL==res.CGSL && x.SBMC==res.SBMC);
                rowIndex === -1 ? this.rows.push(res) : this.rows.splice(rowIndex,res);
            })
        },
        mounted() {
            this.CGJEBZ = this.$route.params.CGJEBZ;
            if (!!this.$route.params.item) {
                this.loadDataDefault(this.$route.params.item);
            }
        },
        methods: {
            upload() { //单子提交审核
                if(!this.data.DH || !this.IsNewAdd){
                    this.$Toast("请先保存申请单，再进行提交审核");
                    return false;
                }
                this.$get('api/SBSG/SabmitSubscribeAudit',{
                    DH:this.data.DH,
                    STORE:this.$UserInfo.StoreCode,
                    GKHM:this.$UserInfo.UserId,
                    SPLX:'1'
                }).then(res=>{
                    if(res!="Y"){
                        this.$Toast(res);
                    }else{
                        this.$Toast({
                            message:'提交审核成功',
                            duration:2000,
                            onClose:()=>{
                                this.$router.go(-1);
                            }
                        })
                    }
                })
            },
            save() { //只保存单子,不进行审核
                if (this.rows.length === 0) {
                    this.$Toast("您还没有添加设备明细!");
                    return false;
                }
                this.$post('api/SBSG/ApplyEquipment', {
                    mdoel: this.rows,
                    model_from: this.data,
                    IsSubmit: false,
                    STORE: this.$UserInfo.StoreCode
                }, 20000).then(result => {
                    console.log(result.DH);
                    if (result.Code === "10000" || result.Code === '10003') { //10000对应的是科室申请  10003对应的是年度计划
                        this.data.DH = result.DH;
                        this.$Toast({
                            message:result.Msg,
                            onClose:()=>{this.loadDataDefault({DH:result.DH})}
                        });
                        this.IsNewAdd=true;
                    } else this.$Toast(result.Msg);
                })
            },
            loadDataDefault(obj) {
                this.$get('api/SBSG/GetSBSGDetail', {
                    Token: 'YTDF5EF3A6174564E5981A446158F106',
                    SBBM: '',
                    JHH: obj.DH
                }).then(result => {
                    if (result.Status) {
                        this.rows = result.rows;
                    } else {
                        this.$Toast(result.Msg);
                    }
                })
            },
            loadpageButton(CGDJ) { //判断购置论证还是申请审批
                return Number(CGDJ) < (Number(this.CGJEBZ) * 10000) ? '申请审批表' : '论证报告';
            },
            ReportGoToUrl(item) { //申请审批表或者购置论证跳转
                !this.data.DH ? this.$Toast({
                    message: '请先保存后,再填写申请审批表或者购置论证',
                    duration: 3000,
                }) : this.$router.push({
                    name: 'ReportApproval',
                    params: {
                        Report: item,
                        ExistsAuditOrReport: Number(item.CGDJ) < Number(this.CGJEBZ) * 10000,
                        DH: this.data.DH,
                        SHZT: this.SHZT
                    }
                })
            }
        },
        components: {
            Box,
            Field,
            Footer,
            [cell.name]:cell
        }
    }
</script>

<style scoped lang="scss">
    .commonBox {
        min-height: 0vw !important;
    }

    .Ask {
        padding-bottom: 112px;
    }

    .infoBox {
        padding: 0 30px;
    }

    .BoxHeight {
        height: 50px;
    }

    .items {
        padding: 36px 30px 24px;

        .itemTopBox {
            border-bottom: 2px solid #eee;

            div {
                display: flex;
                align-items: center;
                font-size: 28px;
                margin-bottom: 18px;

                span:first-child {
                    flex: 1;
                    color: #858585;
                }

                span:last-child {
                    color: $TEXT-DARK-COLOR;
                    font-weight: bold;
                    width: 400px;
                    text-align: right;
                }
            }
        }

        .itemBottomBox {
            margin-top: 32px;
            display: flex;
            align-items: center;
            justify-content: center;

            div {
                width: 300px;
                height: 80px;
                border-radius: 8px;
                text-align: center;
                line-height: 80px;
                font-size: 26px;
                margin-right: 42px;

                &:first-child {
                    background: $THEME-COLOR;
                    color: #fff;
                }

                &:nth-child(2) {
                    background: $THEME-COLOR;
                    color: #fff;
                }

                &:last-child {
                    background: $THEME-COLOR;
                    color: #fff;
                    margin-right: 0;
                }
            }
        }
    }
    .TotalMoney{
        height: 14.933vw;
        position: relative;
        &>span{
            position: absolute;
            top: 30%;
            padding: 0;
            color: #14171a;
            font-size: 4vw;
            &:last-child{
                right: 0;
            }
        }
    }

    .TextColorWHilt{
        color:#666666 !important;
    }

    .van-cell{
        padding: 0;
    }
</style>



// WEBPACK FOOTER //
// src/page/ask/ask.vue